import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LoginService } from '../login/login.service';
import { OrganizationService } from '../translator/organization.service';

@Injectable()
export class AccessTokenInterceptor implements HttpInterceptor {

  constructor(
    private _loginService: LoginService,
    private _organizationService: OrganizationService,
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isApiUrl = request.url.startsWith(environment.backend_url);
    // Skip OIDC token calls — they must not carry Authorization or organizationid.
    const isOidcUrl = request.url.startsWith(environment.oidc.issuer);
    if (this._loginService.isLoggedIn && isApiUrl && !isOidcUrl) {
      const token = this._loginService.access_token;
      const refresh_token = this._loginService.refresh_token;
      const headers: Record<string, string> = {
        authorization: `Bearer ${token}`,
      };
      const organizationId = this._organizationService.getOrganizationId();
      if (organizationId) {
        headers['organizationid'] = organizationId;
      }
      request = request.clone({ setHeaders: headers });
      if (refresh_token) {
        request = request.clone({
          setHeaders: {
            'refresh-token': `${refresh_token}`,
          },
        });
      }
    }
    return next.handle(request);
  }
}
